<mat-dialog-content class="mat-typography p-0">
  <img [src]="data.src">
</mat-dialog-content>
